'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoShuffle = function IoShuffle(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.4 14.1c-4.1 0-6.5 3.4-9.4 7.2-3.2 4.3-6.8 9.4-13.3 9.4h-3.7v-4.9h3.7c4 0 6.5-3.7 9.4-7.5 3.2-4.3 6.8-9.1 13.3-9.1h2.3v-4.2l6.3 6.3-6.3 6.6v-3.8h-2.3z m-16.9 2.9c-1.7-1.6-3.3-2.7-5.8-2.8-2.7-0.1-3.7 0-3.7 0v-4.9h3.7c3.7 0 6.5 1.6 8.8 3.7-0.8 1-1.5 1.9-2.2 2.9-0.3 0.3-0.5 0.7-0.8 1.1z m19.2 8.8v-3.7l6.3 6.6-6.3 6.3v-4.2h-2.3c-3.9 0-6.8-1.8-9.1-4.2 0.9-1.1 1.7-2.1 2.5-3.2 0.1-0.2 0.4-0.4 0.5-0.7 1.7 1.9 3.6 3.1 6.1 3.1h2.3z' })
        )
    );
};

exports.default = IoShuffle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/shuffle.js
// module id = 2410
// module chunks = 0